export const darkTheme = {
  body: 'hsl(300, 100%, 3%)',
  text: 'hsl(0, 0%, 100%)',
  accent: 'hsl(49, 85%, 52%)',
};

export const lightTheme = {
  body: 'hsl(225, 25%, 97%)',
  text: 'hsl(0, 0%, 0%)',
  accent: 'hsl(243, 75%, 59%)',
};
